import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent, COMMON_LANGUAGES, WidgetStyle } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { TerminalContextConstants } from '../../../../model/terminal-context-constants';
import { COMMON_COUNTRIES, Country, Language } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { AppClientConfigurationService } from '@sdbn/common';
import { CommonPropertiesService } from './../../../../common-properties.service';


export class LanguageValue {
  language?: Language;
  country?: Country;
  constructor(value?: Partial<LanguageValue>) {
    if (value != null) {
      this.language = value.language;
      this.country = value.country;
    }
  }
}

@Component({
    selector: 'app-terminal-language-selection',
    templateUrl: './language-selection.component.html',
    styleUrls: ['./language-selection.component.scss'],
    standalone: false
})
export class LanguageSelectionComponent extends AbstractWidgetComponent implements OnInit {

  cardSize = 250;

  public languages = new Array<LanguageValue>();

  public selectedLanguage: string;

  constructor(
    private translationService: TranslationService,
    private cps: AppClientConfigurationService,
    public commonPropertiesService: CommonPropertiesService
  ) {
    super();
  }

  ngOnInit(): void {

    let languages = new Array<LanguageValue>();
    let languagesDefinition = this.cps.getPropertyValue("tmc-yard.terminal.allowed-languages");
    for (const languageKey of languagesDefinition.split("|")) {
      const language = COMMON_LANGUAGES.find(l => l.key === languageKey);
      languages.push(new LanguageValue({ language: language, country: COMMON_COUNTRIES.find(c => c.isoCode === language.countryIsoCode) }));
    }
    this.languages = languages;

    const newCardSize = this.commonPropertiesService.getLanguageSelectionCardSize();
    if (newCardSize != null) {
      this.cardSize = +newCardSize;
    }
  }

  onContextChange(contextChange: ContextChange) { }

  onSetElementAndContext() {
    console.log("onSetElementAndContext", this.widgetReference);
  }

  setLanguage(languageValue: LanguageValue) {
    this.selectedLanguage = languageValue.language.key;
    this.translationService.setLanguage(this.selectedLanguage);
    this.dashboardContext.setContextValue(TerminalContextConstants.language, this.selectedLanguage);
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
